import { forwardRef } from 'react';

import styles from './ShimmerPlaceHolder.module.css';

const defaultLightest = '#e1e1e1';
const defaultDarkest = '#f7f7f7';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  width?: number | string;
  height?: number | string;
  lightest?: string;
  darkest?: string;
}

const ShimmerPlaceholder = forwardRef<HTMLDivElement, Props>(function ShimmerPlaceholder(
  { width, height, lightest = defaultLightest, darkest = defaultDarkest, className, style, ...rest },
  ref,
) {
  const w = typeof width === 'number' ? `${width}px` : width;
  const h = typeof height === 'number' ? `${height}px` : height;
  const bgImage = `linear-gradient(to right, ${lightest} 0%, ${darkest} 20%, ${lightest} 40%, ${lightest} 100%)`;

  return (
    <div
      ref={ref}
      className={`${styles.root} ${className ?? ''}`}
      style={{
        width: w,
        height: h,
        backgroundColor: lightest,
        backgroundImage: bgImage,
        ...style,
      }}
      {...rest}
    />
  );
});

export default ShimmerPlaceholder;
